<h2 mat-dialog-title>New Roadmap - {{region.regionName}}</h2>

<mat-dialog-content>
  <app-loading [isLoading]="isLoading()" message="Loading data..."></app-loading>
  <p class="text-center">We need more information about the project to create a new Lean Roadmap. Please enter all required fields below.</p>
  <form [formGroup]="roadmapForm" class="d-flex flex-column">
    <div class="p-2 d-flex">
      <mat-form-field style="width: 100%">
        <mat-label>Project Name</mat-label>
        <input autocomplete="off" matInput placeholder="What's the name of the project?" formControlName="projectName" required maxlength="300" />
      </mat-form-field>
    </div>
    <div class="px-2 text-end">
      <button matButton="filled" matTooltip="Link Roadmap with Project" matTooltipPosition="right" matTooltipShowDelay="150" (click)="onLinkClick()">
        <fa-icon [icon]="faSearch"></fa-icon> Link To Project
      </button>
    </div>
    <div class="p-2">
      <mat-form-field>
        <input autocomplete="off" matInput placeholder="Job Number" formControlName="projectNumber" required maxlength="25" />
      </mat-form-field>
      <mat-checkbox style="padding-left:20px;" formControlName="isProjectNumberTbd" (change)="onProjectTbdChange($event.checked)"
        matTooltip="Select if you do not have a job number yet (To be decided)" matTooltipPosition="right"
        matTooltipShowDelay="150">No job # (TBD)
      </mat-checkbox>
    </div>
    <div class="p-2 d-flex gap-3">
      <mat-form-field style="width: 300px;">
        <mat-label>Market Segment</mat-label>
        <mat-select formControlName="marketSegment">
          @for (segment of marketSegments; track segment) {
            <mat-option [value]="segment"> {{segment}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width: 300px;">
        <mat-label>Profit Center</mat-label>
        <mat-select formControlName="profitCenter">
          @for (pc of profitCenters; track pc.profitCenterCode) {
            <mat-option [value]="pc.profitCenterCode">{{pc.profitCenterName}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="p-2 d-flex gap-3">
      <mat-form-field style="width: 280px;">
        <mat-label>Roadmap Champion</mat-label>
        <input autocomplete="off" matInput placeholder="Who's the Roadmap Champion?" formControlName="leanChampionName" maxlength="100">
      </mat-form-field>
      <mat-form-field style="width: 280px;">
        <mat-label>Select Approver</mat-label>
        <mat-select formControlName="selectedImApproverAppUserId">
          <!-- <mat-option *ngFor="let approver of approverList" [value]="approver.id" matTooltip="{{approver.networkId}}" matTooltipPosition="left" matTooltipShowDelay="150">
                {{approver.displayName}}
              </mat-option> -->
        </mat-select>
      </mat-form-field>
    </div>
    <div class="p-2">
      Estimated Volume Over $10 Million?
      <mat-radio-group style="margin-left: 20px;" formControlName="isVolumeOver10M">
        <mat-radio-button value="1" style="margin-right: 15px;">Yes</mat-radio-button>
        <mat-radio-button value="0">No</mat-radio-button>
      </mat-radio-group>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="roadmapForm.invalid" (click)="onContinueClick()">Continue</button>
</mat-dialog-actions>
